export default __webpack_public_path__ + "static/media/apple-music.909bcf25.svg";